import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom'

import Activity from 'views/home/home_view'
import SplashScreen from 'views/splash_view/splash_screen'
import WinnerView from 'views/finish/winner_view'
import LoserView from 'views/finish/loser_view'
import RewardView from 'views/finish/reward_view'
import NotFound from 'views/not_found'
import '../src/App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../src/assets/fonts.css'
import ActivityView from 'views/home/activity_view'
import HorrorLand from 'views/home/horrorland_view'
import GameView from 'views/home/game_view'

const App = () => {
  const [canAccessResults, setCanAccessResults] = useState(false)
  const [canAccessReward, setCanAccessReward] = useState(false)

  const allowAccessToResults = () => setCanAccessResults(true)
  const allowAccessToReward = () => setCanAccessReward(true)

  const ProtectedRoute = ({ element: Component, condition, redirectTo }) => {
    const location = useLocation()
    return condition ? <Component /> : <Navigate to={redirectTo} state={{ from: location }} replace />
  }

  return (
     <Router>
      <Routes>
      {/* <Route path="/" element={<RewardView onProceedToReward={allowAccessToReward} />} /> */}
        <Route path="/" element={<SplashScreen />} />
         <Route path="/game/:id" element={<GameView onProceed={allowAccessToResults} />} />
        {/* <Route path="/horrorland" element={<HorrorLand />} /> */}

        <Route path="/:id" element={<SplashScreen />} />
        <Route path="/activity" element={<ActivityView  onProceed={allowAccessToResults} />} />
        <Route path="/activity/*" element={<NotFound />} />
        <Route
          path="/winner"
          // element={<WinnerView></WinnerView>}
          element={
            <ProtectedRoute
              element={() => <WinnerView onProceedToReward={allowAccessToReward} />}
              condition={canAccessResults}
              redirectTo="/"
            />
          }
        />
        <Route path="/winner/*" element={<NotFound />} />
        <Route
          path="/loser"
          // element={<LoserView></LoserView>}
          element={<ProtectedRoute element={LoserView} condition={canAccessResults} redirectTo="/" />}
        />
        <Route path="/loser/*" element={<NotFound />} />
        <Route
          path="/reward"
          // element={<RewardView></RewardView>}
          element={<ProtectedRoute element={() => <RewardView />} condition={canAccessReward} redirectTo="/" />}
        />
        <Route path="/winner/*" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/404" element={<NotFound />} />
      </Routes>
    </Router>
  )
}

export default App
